export function AccessDenied() {
  return (
    <div className="flex min-h-screen items-center justify-center p-8">
      <div className="max-w-md text-center">
        <h1 className="mb-3 text-3xl font-semibold">Access denied</h1>
        <p className="mb-6 text-zinc-400">
          Your Authentik account is not in the group required to use this media viewer.
          Contact your administrator to request access.
        </p>
        <a
          href="/api/auth/logout"
          className="inline-block rounded bg-zinc-800 px-4 py-2 text-sm text-zinc-100 hover:bg-zinc-700"
        >
          Sign out
        </a>
      </div>
    </div>
  );
}
